import { Endpoints } from '@/network';
import { baseForPdf } from '@/services/apiClients';
import { IResponse } from '@/utils/interfaces';
import {
  IGetAllStore,
  IGetAllStoreQueryParams,
} from '@/utils/interfaces/Store';

export const getAllStore = async (
  params: IGetAllStoreQueryParams,
): Promise<IResponse<IGetAllStore>> => {
  const response = await baseForPdf.get(`${Endpoints.store.getAll}`, {
    params,
  });

  return response?.data;
};
